/**
 * Coffret à composer — packs, flacons avec quantités, modal fiche produit,
 * résumé détaillé, panier.
 */
(function () {
  'use strict';

  function ouvrirTiroirPanier() {
    var selecteur = 'cart-drawer-component, cart-drawer, [id*="cart-drawer" i], [class*="cart-drawer" i]';
    var tiroir = document.querySelector(selecteur);
    var sectionEl = tiroir ? tiroir.closest('[id^="shopify-section-"]') : null;

    var declencheurHeader = document.querySelector(
      'header [aria-controls*="cart" i], header a[href$="/cart"], header a[href*="/cart?"], [data-cart-icon], .header__cart'
    );

    function ouvrir() {
      if (declencheurHeader) {
        declencheurHeader.click();
      } else {
        window.location.href = '/cart';
      }
    }

    if (!tiroir || !sectionEl) {
      ouvrir();
      return;
    }

    var sectionId = sectionEl.id.replace('shopify-section-', '');

    fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[sectionId];
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var nouveauTiroir = tmp.querySelector(selecteur);
          if (nouveauTiroir) {
            tiroir.replaceWith(nouveauTiroir);
          }
        }
        ouvrir();
      })
      .catch(ouvrir);
  }

  function initCoffretBuilder(root) {
    var packs = Array.prototype.slice.call(root.querySelectorAll('[data-pack]'));
    var flacons = Array.prototype.slice.call(root.querySelectorAll('[data-flacon]'));
    var btnAjouter = root.querySelector('[data-ajouter]');
    var resumePack = root.querySelector('[data-resume-pack]');
    var resumeListe = root.querySelector('[data-resume-liste]');
    var totaux = root.querySelector('[data-totaux]');
    var zoneResume = root.querySelector('.coffret-builder__resume');
    var elSousTotal = zoneResume.querySelector('[data-sous-total]');
    var ligneRemise = root.querySelector('[data-ligne-remise]');
    var elRemise = zoneResume.querySelector('[data-remise]');
    var elTotal = zoneResume.querySelector('[data-total]');
    var message = root.querySelector('[data-message]');

    if (!btnAjouter || !resumePack) return;

    var texteBouton = btnAjouter.textContent.trim();
    var textePlaceholder = resumePack.dataset.placeholder || '';

    var modal = root.querySelector('[data-modal]');
    var modalImage = root.querySelector('[data-modal-image]');
    var modalMiniatures = root.querySelector('[data-modal-miniatures]');
    var modalSousTitre = root.querySelector('[data-modal-sous-titre]');
    var modalTitre = root.querySelector('[data-modal-titre]');
    var modalDescription = root.querySelector('[data-modal-description]');
    var modalChoisir = root.querySelector('[data-modal-choisir]');
    var modalFermer = root.querySelector('[data-modal-fermer]');
    var flaconModal = null;

    var etat = {
      nbRequis: 0,
      variantIncluse: null,
      label: '',
      sousTotal: '',
      remise: '',
      total: '',
      selection: [] // { variant, nom, qte }
    };

    function totalChoisi() {
      return etat.selection.reduce(function (somme, s) { return somme + s.qte; }, 0);
    }

        function entree(flacon) {
      return etat.selection.find(function (s) {
        return s.variant === flacon.dataset.variantFlacon;
      });
    }

    function selectionnerPack(pack) {
      if (pack.hasAttribute('data-epuise')) return;
      packs.forEach(function (p) {
        p.classList.toggle('est-actif', p === pack);
      });
      etat.nbRequis = parseInt(pack.dataset.count, 10) || 0;
      etat.variantIncluse = pack.dataset.variantInclus;
      etat.label = pack.dataset.label;
      etat.sousTotal = pack.dataset.sousTotal || '';
      etat.remise = pack.dataset.remise || '';
      etat.total = pack.dataset.total || '';
      etat.selection = [];
      majFlacons();
      majResume();
    }

    function changerQte(flacon, delta) {
      if (etat.nbRequis === 0) return;
      var e = entree(flacon);
      if (delta > 0) {
        if (totalChoisi() >= etat.nbRequis) return;
        if (e) {
          e.qte += 1;
        } else {
                    etat.selection.push({
            variant: flacon.dataset.variantFlacon,
            nom: flacon.dataset.nom,
            qte: 1
          });
        }
      } else if (e) {
        e.qte -= 1;
        if (e.qte <= 0) {
          etat.selection = etat.selection.filter(function (s) { return s !== e; });
        }
      }
      majFlacons();
      majResume();
    }

    function majFlacons() {
      var limiteAtteinte = totalChoisi() >= etat.nbRequis;
      flacons.forEach(function (flacon) {
        if (flacon.hasAttribute('data-epuise')) return;
        var e = entree(flacon);
        var qte = e ? e.qte : 0;
        var bloque = etat.nbRequis === 0 || (limiteAtteinte && qte === 0);
        flacon.classList.toggle('est-choisi', qte > 0);
        flacon.classList.toggle('est-grise', bloque);
        flacon.setAttribute('aria-disabled', bloque ? 'true' : 'false');

        var zone = flacon.querySelector('[data-qte]');
        var valeur = flacon.querySelector('[data-qte-valeur]');
        var plus = flacon.querySelector('[data-plus]');
        zone.hidden = qte === 0;
        valeur.textContent = qte;
        plus.disabled = limiteAtteinte;
      });
    }

    function majResume() {
      if (etat.nbRequis === 0) {
        resumePack.textContent = textePlaceholder;
        totaux.hidden = true;
      } else {
        resumePack.textContent =
          etat.label + ' — ' + totalChoisi() + '/' + etat.nbRequis + ' flacon(s)';
        elSousTotal.textContent = etat.sousTotal;
        elTotal.textContent = etat.total;
        var aRemise = etat.remise !== '';
                ligneRemise.hidden = !aRemise;
        elRemise.textContent = aRemise ? etat.remise : '';
        totaux.hidden = false;
      }
      resumeListe.innerHTML = '';
      etat.selection.forEach(function (s) {
        var li = document.createElement('li');
        li.textContent = s.qte > 1 ? s.nom + ' × ' + s.qte : s.nom;
        resumeListe.appendChild(li);
      });
      btnAjouter.disabled =
        etat.nbRequis === 0 || totalChoisi() !== etat.nbRequis;
      message.hidden = true;
    }

    function ouvrirModal(flacon) {
      if (!modal) return;
      flaconModal = flacon;
      modalSousTitre.textContent = flacon.dataset.sousTitre || '';
      modalSousTitre.hidden = !flacon.dataset.sousTitre;
      modalTitre.textContent = flacon.dataset.nom || '';
      modalDescription.textContent = flacon.dataset.description || '';

      var urls = (flacon.dataset.images || '').split('|').filter(Boolean);
      modalMiniatures.innerHTML = '';
      modalImage.src = urls[0] || '';
      modalImage.alt = flacon.dataset.nom || '';
      if (urls.length > 1) {
        urls.forEach(function (url, i) {
          var mini = document.createElement('img');
          mini.src = url;
          mini.alt = '';
          mini.loading = 'lazy';
          if (i === 0) mini.classList.add('est-active');
          mini.addEventListener('click', function () {
            modalImage.src = url;
            modalMiniatures.querySelectorAll('img').forEach(function (m) {
              m.classList.toggle('est-active', m === mini);
            });
          });
          modalMiniatures.appendChild(mini);
        });
      }

      var epuise = flacon.hasAttribute('data-epuise');
      modalChoisir.disabled = epuise || etat.nbRequis === 0;
      modalChoisir.textContent = epuise ? 'Rupture de stock' : 'Choisir ce flacon';

      modal.showModal();
    }

    function fermerModal() {
      modal.close();
      flaconModal = null;
    }

    if (modal) {
      modalFermer.addEventListener('click', fermerModal);
      modal.addEventListener('click', function (e) {
        if (e.target === modal) fermerModal();
      });
      modalChoisir.addEventListener('click', function () {
        if (flaconModal && !flaconModal.hasAttribute('data-epuise')) {
          changerQte(flaconModal, 1);
        }
        fermerModal();
      });
    }

    packs.forEach(function (pack) {
      pack.addEventListener('click', function () {
        selectionnerPack(pack);
      });
      pack.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectionnerPack(pack);
        }
      });
    });

    flacons.forEach(function (flacon) {
      flacon.addEventListener('click', function (e) {
        if (e.target.closest('[data-info]')) {
          e.stopPropagation();
          ouvrirModal(flacon);
          return;
        }
        if (e.target.closest('[data-plus]')) {
          e.stopPropagation();
          changerQte(flacon, 1);
          return;
        }
        if (e.target.closest('[data-moins]')) {
          e.stopPropagation();
          changerQte(flacon, -1);
          return;
        }
        changerQte(flacon, 1);
      });
      flacon.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          changerQte(flacon, 1);
        }
      });
    });

    btnAjouter.addEventListener('click', function () {
      if (btnAjouter.disabled) return;
      btnAjouter.disabled = true;
      btnAjouter.textContent = 'Ajout en cours…';

      var numero = new Date().getTime().toString().slice(-4);
      var proprietes = { 'Coffret': etat.label + ' — n°' + numero };
      var items = [
        { id: parseInt(etat.variantIncluse, 10), quantity: 1, properties: proprietes }
      ];
      etat.selection.forEach(function (s) {
        items.push({
          id: parseInt(s.variant, 10),
          quantity: s.qte,
          properties: proprietes
        });
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (reponse) {
          if (!reponse.ok) throw new Error('Erreur panier');
          btnAjouter.textContent = texteBouton;
          btnAjouter.disabled = false;
          ouvrirTiroirPanier();
        })
        .catch(function () {
          btnAjouter.disabled = false;
          btnAjouter.textContent = texteBouton;
          message.textContent =
            "L'ajout au panier a échoué. Vérifiez les stocks et réessayez.";
          message.hidden = false;
        });
    });
  }

  function initTous() {
    document.querySelectorAll('[data-coffret-builder]').forEach(initCoffretBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTous);
  } else {
    initTous();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-coffret-builder]');
    if (root) initCoffretBuilder(root);
  });
})();